/* global axios */
import ApiClient from './ApiClient';

class PartnersAPI extends ApiClient {
  constructor() {
    super('partners', { accountScoped: true });
  }

  // O `get` da base não aceita parâmetros e é herdado por dezenas de recursos;
  // ampliá-lo por causa de um filtro daqui teria raio de alcance grande demais.
  //
  // `axios` aqui é o global que a aplicação configura com os interceptors de
  // autenticação — importar a biblioteca crua manda a requisição sem sessão.
  get(params) {
    return params ? axios.get(this.url, { params }) : axios.get(this.url);
  }
}

export default new PartnersAPI();
